// extracted by mini-css-extract-plugin
export default {"innerWrapper":"uH-z","tooltipWrapper":"vH-z","icon":"wH-z","tooltip":"xH-z","content":"yH-z"};